import React, { FunctionComponent } from 'react';

import { ListItem, ListItemProps } from '@yandex-360/orb-components/dist/components/ListItem';
import { Tumbler, TumblerProps } from '@yandex-360/orb-components/dist/components/Tumbler';

import css from './styles.css';

export interface SettingsTumblerProps
    extends Pick<TumblerProps, 'checked' | 'onChange' | 'testId'>,
        Pick<ListItemProps, 'label' | 'description'> {
    disabled?: boolean;
    midSlot?: React.ReactNode;
}

export const SettingsTumbler: FunctionComponent<SettingsTumblerProps> = ({
    disabled = false,
    label,
    description,
    midSlot,
    ...tumblerProps
}) => {
    return (
        <label className={css.label}>
            <ListItem
                className={css.row}
                label={label}
                description={description}
                disabled={disabled}
                endSlot={
                    <div className={css.endSlot}>
                        {midSlot}
                        <Tumbler {...tumblerProps} view="orb" size="md" disabled={disabled} />
                    </div>
                }
                interaction={false}
            />
        </label>
    );
};
